import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { appSetting } from "../../../config/appSettings";
import { AuthService } from 'modules/app/services/auth.service';

import { ApiGatewayHelperService } from '../../app/services/apigateway-helper.service';

@Injectable()
export class LTILaunchService  {

    constructor(
        private http: HttpClient, 
        private apiGatewayHelperService: ApiGatewayHelperService,
        private authService: AuthService,

    ){}
    
    public launchSources = [
        'TEACHER_CREATE_ASSIGNMENT',
        'LEARNER_ATTEMPT_ASSIGNMENT',
        'TEACHER_VIEW_ASSIGNMENT',
        'TEACHER_REVIEW_TEST',
        'LEARNER_REVIEW_TEST',
        'TEACHER_PREVIEW_MATERIALS',
        'TEACHER_PREVIEW_LIBRARY',
        'LEARNER_LAUNCH_FROM_DASHBOARD',
        'TEACHER_CEFR_REVIEW_TEST',
        'LEARNER_CEFR_REVIEW_TEST',
        'TEACHER_EDIT_ASSIGNMENT',
        'GRADE_ACTIVITY_SELECTION',
        'CREATE_ACCESS_RULE'
    ]   

    getLtiLaunchParams(toolRef):Observable<any> {
    let url = `${this.apiGatewayHelperService.getApiGatewayPrefixUrl()}lti/toolsData/${toolRef}`;
          return this.http.get(url).pipe(
              map(res => {
                return res;
              })
          ) 
    }

    setDataInLocalStorage(dataObject) {
        const key = this.generateLtiReturnUrlKey(dataObject.itemCode, dataObject.attempt.id);
        const localStorageKey = this.generateLocalStorageKey(key);
        localStorage.setItem(localStorageKey, JSON.stringify(dataObject));
        return encodeURIComponent(key);
    }

    getDataFromLocalStorage(encodedKey) {
        const ltiReturnUrlKey = decodeURIComponent(encodedKey);
        const localStorageKey = this.generateLocalStorageKey(ltiReturnUrlKey);
        const data = localStorage.getItem(localStorageKey);
        localStorage.removeItem(localStorageKey);
        return JSON.parse(data);
    }

    generateLocalStorageKey(ltiReturnUrlKey) {
        const userData = this.authService.getUserData();
        return `${appSetting.localStorage.genericLtiReturnUrlKey}${userData.extUserId}.${ltiReturnUrlKey}`;
    }

    generateLtiReturnUrlKey(...args) {
        const keyDelimiter = '-';
        return args.join(keyDelimiter);
    }
}